import React from 'react';
import { useEvents } from '../../providers/events';
import { isImage } from '../../../../helpers/attachments/isImage';
import ImageIcon from './ImageIcon';
import PdfIcon from './PdfIcon';
import IconTemplate from './IconTemplate';
import { useAttachment } from '../../providers/attachment';

const extensionToType = {
  '.txt': 'file-text',
  '.doc': 'file-word',
  '.docx': 'file-word',
  '.xls': 'file-excel',
  '.xlsx': 'file-excel',
};

const IconBlock = () => {
  const attachment = useAttachment();

  const { getExtension } = useEvents();

  const ext = getExtension(attachment);

  if (isImage(ext)) {
    return <ImageIcon attachment={attachment} />;
  }

  if (ext === '.pdf') {
    return <PdfIcon attachment={attachment} />;
  }

  return <IconTemplate iconType={extensionToType[ext] ?? 'file'} />;
};

export default IconBlock;
